export const headers = {
  //
  execucao: [
    { text: 'Grupo', value: 'grupo' },
    { text: 'Município', value: 'municipio' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Responsável', value: 'responsavel' },
    { text: 'Horas Previstas', value: 'horasPrevistas' },
    { text: 'Horas Executadas', value: 'horasRealizadas' },
    { text: '%', value: 'percentual' }
  ],
  execucao_por_tarefas: [
    { text: 'Grupo', value: 'grupo' },
    { text: 'Município', value: 'municipio' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Responsável', value: 'responsavel' },
    { text: 'Tarefas Previstas', value: 'horasPrevistas' },
    { text: 'Tarefas Executadas', value: 'horasRealizadas' },
    { text: '%', value: 'percentual' }
  ],
  relatorio_por_solucao: [
    { text: 'Grupo', value: 'grupo' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Município', value: 'municipio' },
    { text: 'Data', value: 'data' },
    { text: 'Responsável', value: 'responsavel' },
    { text: 'Relatório', value: 'relatorio' },
    { text: 'Tarefas', value: 'tarefas' },
    { text: 'Horas', value: 'horas' },
    { text: 'Situação', value: 'situacao' }
  ],
  encontros_por_solucao: [
    { text: 'Título', value: 'titulo' },
    { text: 'Responsável', value: 'responsavel' },
    { text: 'Município', value: 'municipio' },
    { text: 'Data', value: 'data' },
    { text: 'Tem Relatório', value: 'relatorio' }
  ],
  situacaoVisitas: [
    { text: 'Município', value: 'municipio' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Responsavel', value: 'responsavel' },
    { text: 'Status', value: 'situacao' },
    { text: 'Visitas', value: 'visitas' }
  ],
  situacaoTarefa: [
    { text: 'Município', value: 'municipio' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Responsavel', value: 'responsavel' },
    { text: 'Tarefa', value: 'tarefa' },
    { text: 'Data', value: 'dataEvento', align: 'start' },
    { text: 'Status', value: 'situacao' }
  ],
  diagnostico: [
    { text: 'Município', value: 'municipio', align: 'start' },
    { text: 'Eixo', value: 'eixo', align: 'start' }
  ],
  diagnosticoFinalizado: [
    { text: 'Município', value: 'nomeMunicipio', align: 'start' },
    { text: 'Eixo', value: 'nome', align: 'start' },
    { text: 'Pontos ', value: 'pontos', align: 'start' }
  ],
  evidencias: [
    { text: 'Município', value: 'municipio', align: 'start' },
    { text: 'Eixo', value: 'eixo' },
    { text: 'Questões não evidenciadas', value: 'semEvidencias' }
  ],
  rejeicao: [
    { text: 'Município', value: 'municipio' },
    { text: 'Eixo', value: 'eixo' },
    { text: 'Respondidas', value: 'respondidas' },
    { text: 'Evidenciadas', value: 'evidenciadas' },
    { text: 'Aguardando Análise', value: 'aguardandoAnalise' },
    { text: 'Aprovadas', value: 'aprovadas' },
    { text: 'Rejeitadas', value: 'rejeitadas' }
  ],
  execucao_hora: [
    { text: 'Município', value: 'municipio' },
    { text: 'Horas Previstas', value: 'horasPrevistas' },
    { text: 'Horas Realizadas', value: 'horasRealizadas' },
    { text: 'Percentual', value: 'percentual' },
    { text: 'Responsável', value: 'responsavel' },
    { text: 'Solução', value: 'solucao' },
  ],
  situacao_medalha: [
    { text: 'Município', value: 'nome' },
    { text: 'Tema', value: 'nomeTema' },
    { text: 'Medalha Bronze', value: 'possuiBronze' },
    { text: 'Medalha Prata', value: 'possuiPrata' },
    { text: 'Medalha Ouro', value: 'possuiOuro' },

  ],
  situacao_medalha_pontos_tema: [
    { text: 'Município', value: 'nome' },
    { text: 'Região', value: 'nomeRegiao' },

    { text: 'Tema', value: 'nomeTema' },
    { text: 'Pontos', value: 'pontos' },
    { text: 'Pontos de acompanhamento', value: 'acompanhamentosPontos' },

    { text: 'Medalha Bronze', value: 'bronze' },
    { text: 'Medalha Prata', value: 'prata' },
    { text: 'Medalha Ouro', value: 'ouro' },

  ],
  execucao_tarefas_inicio_fim: [
    { text: 'Município', value: 'municipio' },

    { text: 'Início', value: 'inicio' },
    { text: 'Fim', value: 'fim' },
    { text: 'Projeto', value: 'projeto' },
    { text: 'Percentual', value: 'percentual' },
    { text: 'Solução', value: 'solucao' },
    { text: 'Tarefas Previstas', value: 'tarefasPrevistas' },
    { text: 'Tarefas Realizadas', value: 'tarefasRealizadas' },
  ]
}
